import { Enums } from '@bode-canada/core';

const {
  BuildingTypeEnum,
  BuildingClassEnum,
  PropertyHomeTypeEnum,
  UnitTypeEnum,
} = Enums;

export const ALLOWED_BUILDING_CLASSES = [
  BuildingClassEnum.DETACHED,
  BuildingClassEnum.SEMI_DETACHED,
  BuildingClassEnum.ROW_TOWNHOUSE,
];

export const ALLOWED_BUILDING_TYPES = [
  BuildingTypeEnum.LOW_RISE_APARTMENT,
  BuildingTypeEnum.HIGH_RISE_APARTMENT,
];

export const PROPERTY_HOME_STYLES = [
  PropertyHomeTypeEnum.ONE_AND_HALF_STOREY,
  PropertyHomeTypeEnum.TWO_STOREY,
  PropertyHomeTypeEnum.TWO_AND_HALF_STOREY,
  PropertyHomeTypeEnum.THREE_STOREY,
  PropertyHomeTypeEnum.BI_LEVEL,
  PropertyHomeTypeEnum.TWO_STOREY_SPLIT,
  PropertyHomeTypeEnum.THREE_LEVEL_SPLIT,
  PropertyHomeTypeEnum.FOUR_LEVEL_SPLIT,
  PropertyHomeTypeEnum.FIVE_LEVEL_SPLIT,
  PropertyHomeTypeEnum.BUNGALOW,
];

export const UNIT_TYPES = [
  UnitTypeEnum.LOFT,
  UnitTypeEnum.SINGLE_LEVEL_UNIT,
  UnitTypeEnum.MULTI_LEVEL_UNIT,
];

export const COMPARABLES_BUILDING_TYPES = [
  ...ALLOWED_BUILDING_CLASSES,
  ...ALLOWED_BUILDING_TYPES,
  BuildingClassEnum.VACANT_LAND,
];

export const COMPARABLE_STYLE = [
  ...PROPERTY_HOME_STYLES,
  ...UNIT_TYPES,
];
